<template>
  <div class="overlay">
    <slot />
  </div>
</template>

<script>
export default {
  name: "BaseOverlay"
};
</script>

<style lang="scss" scoped>
.overlay {
  @include absolute(top 0 right 0 bottom 0 left 0);
  @include flex-centered();

  background-color: rgba(0, 0, 0, .7);
  color: $color-white;
  font-size: $font-size-l;
  text-align: center;
}
</style>
